import sessionStore from 'client/Session/SessionStore';
import constants from 'client/constants';

export type FooterColumn = {
  key: string;
  title: string;
  items: FooterDataItem[];
};

export type FooterDataItem = {
  label: string;
  link?: string;
  type?: FooterItemType;
  icon?: string;
};

type FooterItemType = 'title' | 'link';

const footerData: FooterColumn[] = [
  {
    key: 'get-started',
    title: 'Get Started',
    items: [
      {
        label: 'Sign Up',
        link: '/signup'
      },
      {
        label: 'Course Library',
        link: '/subjects'
      },
      {
        label: 'Schedule a Demo',
        link: 'https://albert-licenses.typeform.com/to/Yv8f75Vi?utm_source=site-footer'
      }
    ]
  },
  {
    key: 'company',
    title: 'Company',
    items: [
      {
        label: 'About Us',
        link: '/about-our-team'
      },
      {
        label: 'Careers',
        link: 'https://careers.albert.io'
      },
      {
        label: 'Blog',
        link: '/blog'
      }
    ]
  },
  {
    key: 'solutions',
    title: 'Solutions',
    items: [
      {
        label: 'Advanced Placement®',
        link: '/solutions-ap'
      },
      {
        label: 'SAT® and ACT®',
        link: '/solutions-college-entrance'
      },
      {
        label: 'English Language Learners',
        link: '/solutions/Support-for-English-Learners'
      },
      {
        label: 'Albert Adaptive | Early Access',
        link: '/solutions/albert-adaptive'
      }
    ]
  },
  {
    key: 'product',
    title: 'Product',
    items: [
      {
        label: 'Teachers',
        link: '/solutions-teachers'
      },
      {
        label: 'Admins',
        link: '/solutions-admins'
      },
      {
        label: 'Testimonials',
        link: '/solutions/testimonials'
      },
      {
        label: 'Technical Requirements',
        link: '/software-considerations'
      }
    ]
  },
  {
    key: 'contact-us',
    title: 'Contact us',
    items: [
      {
        label: 'SUPPORT',
        type: 'title'
      },
      {
        label: 'Help Center',
        icon: 'headset',
        link: 'https://help.albert.io'
      },
      {
        label: constants.CONTACT.EMAIL.SUPPORT,
        icon: 'envelope',
        link: `mailto:${constants.CONTACT.EMAIL.SUPPORT}`
      },
      {
        label: 'SALES',
        type: 'title'
      },
      {
        label: constants.CONTACT.EMAIL.SALES,
        icon: 'envelope',
        link: `mailto:${constants.CONTACT.EMAIL.SALES}`
      }
    ]
  }
];

export const getFooterData = (): FooterColumn[] => {
  // add login link to footer if the user is unauthenticated - first column.
  if (!sessionStore.hasValidSession()) {
    const loginItem: FooterDataItem = {
      label: 'Log In',
      link: '/log-in'
    };
    const [firstColumn, ...restColumns] = footerData;
    const footerDataUpdated: FooterColumn[] = [
      {...firstColumn, items: [loginItem, ...firstColumn.items]},
      ...restColumns
    ];

    return footerDataUpdated;
  }
  return footerData;
};
